import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { Angle } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import './DidNotFindResourceItem.scss';

import { fixedEncodeURIComponent } from '@bibliocommons/utils-browser';

const renderResourceTags = (resourceTags) =>
  resourceTags.map((tag, index) => (
    <span>
      <FormattedMessage id={`${tag}`} />
      { index < resourceTags.size - 1 ? ' | ' : ''}
    </span>
  ));

const injectQueryIntoUrl = (query, url) =>
    (query && url) ? url.replace(/{query}/gi, fixedEncodeURIComponent(query)) : url;

export default function DidNotFindResourceItem({ className, query, resourceName, resourceDescription, resourceTags, resourceLink }) {
  return (
    <li className={`resource-item ${className}`}>
      {resourceName &&
        <h5 className="resource-name">
          { resourceName }
        </h5>}
      {resourceDescription &&
        <div
          className="resource-description">
          { resourceDescription }
        </div>
      }
      <div className="resource-tags">
        {renderResourceTags(resourceTags)}
      </div>
      {resourceLink &&
        <a
          className={`did-not-find-resource-link-${resourceName}`}
          href={injectQueryIntoUrl(query, resourceLink)}>
          <span aria-hidden>
            <FormattedMessage id="search_link_text" />
            <Angle.Right />
          </span>
          <ScreenReaderMessage>
            <FormattedMessage id="ada_opens_a_new_tab" values={{ linkText: <FormattedMessage id="search_link_text" /> }} />
          </ScreenReaderMessage>
        </a>}
    </li>
  );
}

DidNotFindResourceItem.propTypes = {
  className: PropTypes.string,
  query: PropTypes.string,
  resourceName: PropTypes.string,
  resourceDescription: PropTypes.node,
  resourceTags: ImmutablePropTypes.list,
  resourceLink: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/search/DidNotFindResourceItem/DidNotFindResourceItem.jsx